import styled from 'styled-components';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { PushPrimaryContent } from 'modules/campaigns/editor/types';
import { InfoBadge } from 'modules/campaigns/editor/styles';
import { LightText, StyledNewTabLink } from '../Sections.styled';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

const MediaUrlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7.5px;
`;

export const PushContent = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { title, message, attachmentUrlIos, attachmentUrlAndroid } =
    primaryContent as PushPrimaryContent;
  return (
    <>
      <CampaignFormField labelText="Title">
        <ReadOnlyField name="title">{title || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Body">
        <ReadOnlyField name="message">{message || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Media URL">
        <ReadOnlyField name="mediaURL">
          {attachmentUrlIos || attachmentUrlAndroid ? (
            <MediaUrlWrapper>
              {attachmentUrlIos && (
                <ReadOnlyField name="apple">
                  <InfoBadge>iOS</InfoBadge>
                  <StyledNewTabLink href={attachmentUrlIos}>{attachmentUrlIos}</StyledNewTabLink>
                </ReadOnlyField>
              )}
              {attachmentUrlAndroid && (
                <ReadOnlyField name="android">
                  <InfoBadge>Android</InfoBadge>
                  <StyledNewTabLink href={attachmentUrlAndroid}>
                    {attachmentUrlAndroid}
                  </StyledNewTabLink>
                </ReadOnlyField>
              )}
            </MediaUrlWrapper>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
